angular.module('gym.reports').controller('ShowReportCtrl', ["$scope", "$state", "$stateParams", "$http", "$modal", "ngTableParams", "Reports", "report", "reports", "loadingAnimation", "flash", "gym", "EmploymentService", "GTMService", "AdminUserService", "SubscriptionPlanLimitService", "MasqueradingService", "ReactModal", function($scope, $state, $stateParams, $http, $modal, ngTableParams, Reports, report, reports, loadingAnimation, flash, gym, EmploymentService, GTMService, AdminUserService, SubscriptionPlanLimitService, MasqueradingService, ReactModal) {
  var defaultSortOrder, displayExportDisabled, getCurrentExports;
  $scope.report = report;
  $scope.reports = reports;
  $scope.units = gym.attributes.units;
  $scope.permissions = EmploymentService.get().permissions;
  $scope.scheduledReportExportsEnabled = gym.attributes.scheduled_report_exports_enabled;
  $scope.adminHasPermission = AdminUserService.has;
  $scope.isMasquerading = MasqueradingService.isMasquerading();
  $scope.gym_config = gym.attributes.gym_config;
  GTMService.trackPage('Custom Report details');
  $scope.isMembershipImportAvailable = function() {
    return $scope.report.rows.length > 0 && ($scope.isMasquerading || ($scope.gym_config.can_start_membership_bulk_imports && $scope.permissions.perform_bulk_imports));
  };
  $scope.toggleFavourite = function() {
    var action;
    action = report.is_favourite ? 'unfavourite' : 'favourite';
    return report.customPUT('', action).then(function(data) {
      return report.is_favourite = !report.is_favourite;
    });
  };
  $scope.setPrivate = function(value) {
    var action;
    GTMService.trackPage('Custom Report details', 'Change visibilty');
    action = value ? 'set_private' : 'set_public';
    return report.customPUT('', action).then(function(data) {
      return report.private = value;
    });
  };
  $scope.toggleLock = function() {
    var action;
    GTMService.trackPage('Custom Report details', 'lock report');
    action = report.locked ? 'unlock' : 'lock';
    return report.customPUT('', action).then(function(data) {
      return report.locked = !report.locked;
    });
  };
  $scope.clone = function() {
    GTMService.trackPage('Custom Report details', 'clone report');
    return report.customPUT('', 'clone').then(function(report) {
      $state.go('gym.reports.show', {
        reportId: report.id
      });
      return flash.success = 'Report cloned successfully.';
    }, function(response) {
      SubscriptionPlanLimitService.validate(response.data);
      if (!response.data.subscription_limit_exceeded) {
        return flash.error = 'Unable to clone this report';
      }
    });
  };
  $scope.isBulkUpdateAvailable = function() {
    return $scope.report.rows.length > 0 && $scope.isMasquerading;
  };
  $scope.performBulkAction = function() {
    return ReactModal.open({
      component: 'PerformReportBulkActionsDrawer',
      props: {
        report: report
      },
      drawer: true
    });
  };
  $scope.performMembershipImport = function() {
    return ReactModal.open({
      component: 'StartMembershipImportModal',
      props: {
        report: report
      },
      drawer: true
    });
  };
  displayExportDisabled = function() {
    return $modal.open({
      template: require('templates/gyms/reports/export_disabled_modal.html.slim'),
      controller: ["$scope", "$modalInstance", function($scope, $modalInstance) {
        return $scope.close = function() {
          return $modalInstance.close();
        };
      }]
    });
  };
  $scope.export = function(format) {
    var checkStatusUrl, gymId;
    gymId = gym.attributes.id;
    checkStatusUrl = `/gyms/${gymId}/email_overrides/check_status?email_type=report_export`;
    return $http.get(checkStatusUrl).then(function(response) {
      if (response.data.enabled) {
        GTMService.trackPage('Custom Report details', 'export');
        return report.customPUT('', 'export', {
          export_format: format
        }).then(function(data) {
          return flash.success = `Your report is currently being generated. When it is complete, an email will be sent to ${report.current_user_email}.`;
        });
      } else {
        return displayExportDisabled();
      }
    }, function() {
      return displayExportDisabled();
    });
  };
  getCurrentExports = function() {
    return $scope.report.all('export_schedules').getList().then(function(data) {
      return $scope.enabledExport = data.find(function(item) {
        return item.user_id === window.currentUser.id;
      });
    });
  };
  if ($scope.scheduledReportExportsEnabled) {
    getCurrentExports();
  }
  $scope.stopRecurringExports = function() {
    if (window.confirm(`Stop sending recurring exports of this report to ${window.currentUser.email}?`)) {
      return $scope.enabledExport.remove().then(function() {
        flash.success = "Updated successfully";
        return getCurrentExports();
      });
    }
  };
  $scope.scheduleExports = function() {
    var modalInstance;
    modalInstance = $modal.open({
      template: require('templates/gyms/reports/schedule_exports_modal.html.slim'),
      controller: 'ScheduleExportsCtrl',
      resolve: {
        report: function() {
          return $scope.report;
        },
        exportId: function() {
          var ref;
          return (ref = $scope.enabledExport) != null ? ref.id : void 0;
        }
      }
    });
    return modalInstance.result.then(function() {
      return getCurrentExports();
    }, function() {
      return getCurrentExports();
    });
  };
  $scope.isPayor = window.currentUser.account_owner;
  $scope.allScheduleExports = function() {
    var modalInstance;
    modalInstance = $modal.open({
      template: require('templates/gyms/reports/all_scheduled_exports_modal.html.slim'),
      controller: 'AllScheduledExportsCtrl',
      size: 'lg',
      resolve: {
        report: function() {
          return $scope.report;
        }
      }
    });
    return modalInstance.result.then(function() {
      return getCurrentExports();
    }, function() {
      return getCurrentExports();
    });
  };
  $scope.isCellNumber = function(column, aggregateLabelPresent) {
    var ref;
    if ((ref = column != null ? column.data_type : void 0) === 'number' || ref === 'currency') {
      return true;
    }
    if ((column == null) && aggregateLabelPresent) {
      return true;
    }
    return false;
  };
  $scope.editable = function() {
    return $scope.report.is_creator || !$scope.report.locked;
  };
  $scope.edit = function() {
    if ($scope.editable()) {
      GTMService.trackPage('Custom Report details', 'edit');
      return $state.go('gym.reports.edit', {
        reportId: report.id
      });
    } else {
      return flash.error = 'This report has been locked and cannot be edited except by the person who created it.';
    }
  };
  $scope.orderBy = function(column) {
    $scope.orderChanged = true;
    $scope.tableParams.$params.sort_by = column.id;
    return $scope.tableParams.$params.sort_dir = $scope.pageParams.sort_dir === 'ASC' ? 'DESC' : 'ASC';
  };
  $scope.isSaveOrderAllowed = function() {
    return $scope.orderChanged && (!$scope.report.locked || $scope.report.is_creator);
  };
  $scope.saveOrder = function() {
    var params;
    params = {
      sort_by: $scope.pageParams.sort_by,
      sort_dir: $scope.pageParams.sort_dir
    };
    return report.customPUT('', 'change_sort_order', params).then(function() {
      $scope.orderChanged = false;
      return flash.success = 'Current order has been saved';
    });
  };
  defaultSortOrder = _.findWhere(report.report_columns_attributes, {
    sort_by: true
  });
  $scope.pageParams = {
    page: '1',
    count: '10',
    sort_by: defaultSortOrder != null ? defaultSortOrder.id : void 0,
    sort_dir: defaultSortOrder != null ? defaultSortOrder.sort_by_direction : void 0
  };
  $scope.pageRange = function() {
    var fromCount, prevPagesCount;
    prevPagesCount = ($scope.pageParams.page - 1) * $scope.pageParams.count;
    fromCount = $scope.report.rows.length ? prevPagesCount + 1 : 0;
    return `${fromCount} - ${prevPagesCount + $scope.report.rows.length}`;
  };
  $scope.setPageSize = function(count) {
    return $scope.tableParams.count(count);
  };
  $scope.filterByTag = function(tag) {
    return $state.go('gym.reports.list', {
      tags: tag
    });
  };
  $scope.reload = function() {
    return $scope.tableParams.reload();
  };
  return $scope.tableParams = new ngTableParams($scope.pageParams, {
    counts: [],
    total: 0,
    getData: function($defer, $params) {
      if (!$scope.initialized) {
        $defer.resolve(report.rows);
        $params.total(report.total_result_count);
        return $scope.initialized = true;
      } else {
        loadingAnimation.show();
        return Reports.get($stateParams.reportId, $params.url()).then(function(data) {
          $params.total(data.total_result_count);
          $scope.pageParams = $params.url();
          $scope.report = angular.extend($scope.report, data);
          $defer.resolve(data.rows);
          return loadingAnimation.hide();
        }, function() {
          flash.error = "Request could not be completed. Please try again";
          return loadingAnimation.hide();
        });
      }
    }
  });
}]);
